export enum SystemActionLogType {
  DEACTIVATE_SYSTEM = "DEACTIVATE_SYSTEM",
  SET_SYSTEM_DOWNLOAD_VERSION = "SET_SYSTEM_DOWNLOAD_VERSION",
}
